import React, { useEffect } from 'react';
import UnifiedHeader from '../layout/UnifiedHeader';
import Footer from '../layout/Footer';
import { updateMeta } from '../../utils/meta';
import { setJsonLdWithId } from '../../utils/seo';

const LOCATIONS: Record<string, { title: string; h1: string; desc: string }> = {
  imphal: {
    title: 'Web Development in Imphal - Paokhum',
    h1: 'Website Design & CCTV Solutions in Imphal',
    desc: 'Modern websites and CCTV web streaming for businesses in Imphal. Local expertise, transparent pricing, fast delivery.'
  },
  guwahati: {
    title: 'Web Development in Guwahati - Paokhum',
    h1: 'Website Design & CCTV Solutions in Guwahati',
    desc: 'We build high-performance websites and secure CCTV streaming solutions for Guwahati businesses.'
  },
  nagaland: {
    title: 'Web Development in Nagaland - Paokhum',
    h1: 'Website Design & CCTV Solutions in Nagaland',
    desc: 'Full-stack website development and CCTV for organizations across Nagaland.'
  },
  northeast: {
    title: 'Web Development in Northeast India - Paokhum',
    h1: 'Website Design & CCTV Solutions across Northeast India',
    desc: 'Serving the Northeast with modern websites, branding and CCTV web integration.'
  }
};

export const LocationPage: React.FC<{ slug: keyof typeof LOCATIONS }> = ({ slug }) => {
  const data = LOCATIONS[slug];

  useEffect(() => {
    const origin = window.location.origin;
    updateMeta({
      title: data.title,
      description: data.desc,
      image: '/images/og/home.svg',
      url: origin + `/locations/${slug}`
    });

    // LocalBusiness + Service JSON-LD
    try {
      setJsonLdWithId(`lb-${slug}`, {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Paokhum",
        "url": origin + `/locations/${slug}`,
        "image": origin + "/Paokhum_logo_favicon.svg",
        "areaServed": [slug.charAt(0).toUpperCase() + slug.slice(1), "Northeast India"],
        "telephone": "+91-97744-77416"
      });
      setJsonLdWithId(`svc-${slug}`, {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Website Development & CCTV Streaming",
        "provider": { "@type": "Organization", "name": "Paokhum" },
        "areaServed": [slug.charAt(0).toUpperCase() + slug.slice(1), "Northeast India"],
        "serviceType": "Web Development"
      });
    } catch {}
  }, [slug, data]);

  return (
    <div className="relative">
      <UnifiedHeader />
      <main className="min-h-screen relative">
        <section className="py-24">
          <div className="container mx-auto px-6">
            <h1 className="text-4xl font-display font-extrabold mb-4">{data.h1}</h1>
            <p className="text-foreground/70 mb-6 max-w-3xl">{data.desc}</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

